module.exports = __webpack_public_path__ + "img/57600.edabde84.jpg";